import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useApproveSuggestedContentPreviewMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: { values: Api.IContentCalendarSuggestion[]; count: number }) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			calendarId,
			impersonationContext,
		}: {
			impersonationContext?: Api.IImpersonationContext;
			calendarId: string;
		}) => {
			return userSession.webServiceHelper.callAsync<{ values: Api.IContentCalendarSuggestion[]; count: number }>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `ContentCalendarSuggestion/calendar/${calendarId}/confirm/preview`,
					impersonationContext,
				}),
				'GET',
				null
			);
		},
		onError,
		onSuccess,
	});
};
